import { getQueryParams } from '@/infrastructure/Utils'

export default () => {
  const waittingUTAG = (errorMessage) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(
          global.trackingService.captureAnalyticsErrors(errorMessage?.title || errorMessage?.message || errorMessage, errorMessage?.status),
          global.trackingService.triggerAnalyticsEvent()
        )
      }, 1000)
    })
  }

  const createErrorModal = (errorMessage, button) => {
    const options = {
      backdrop: 'static',
      keyboard: false
    }
    const text = { title: errorMessage?.title || errorMessage?.message || errorMessage }
    global.ModalMessage
      .modal('#modal-error')
      .text(text)
      .options(options)
      .button(button)
      .show()

    waittingUTAG(errorMessage)
  }

  const errorFactoryModal = (error = {}, translate) => {
    const buttonErrorRate = {
      show: true,
      label: translate('modalErrorRateUnavailableForBookingCta'),
      url: window.location.href
    }
    let buttonErrorGeneric = {
      show: true,
      label: translate('errBoGenericModalCta'),
      url: window.location.href
    }
    const msgError = { title: '' }

    switch (error.type) {
      case global.ProblemTypes.rateUnavailableForBooking:
        createErrorModal(global.ProblemTypes.rateUnavailableForBooking, buttonErrorRate)
        break

      case global.ProblemTypes.roomClosed:
        createErrorModal(global.ProblemTypes.roomClosed, buttonErrorRate)
        break

      case global.ProblemTypes.checkoutInvalidParameterError:
        createErrorModal(error, buttonErrorGeneric)
        break

      case global.ProblemTypes.invalidDates:
        buttonErrorGeneric = {
          show: true,
          label: translate('errBoInvalidDatesModalCta'),
          click: () => {
            const { hotelCode } = getQueryParams(window.location.search)
            // patch for integrate with searchBar
            global.selectedHotel = {
              code: hotelCode
            }
            global.searchBarVue.$emit('open-searchbar-modal', {})
            $('.modal-backdrop').remove()
          }
        }
        createErrorModal(error, buttonErrorGeneric)
        break

      case global.ProblemTypes.internalServerError:
        createErrorModal(error, buttonErrorGeneric)
        break

      case global.ProblemTypes.promocodeQuantityOfUsesExceeded:
        msgError.title = translate('rdPromoErrorQuantityOfUSes')
        createErrorModal(msgError, buttonErrorGeneric)
        break

      case global.ProblemTypes.promocodeOffersArentApplicable:
        msgError.title = translate('rdPromoErrorOffersNotApplicable')
        createErrorModal(msgError, buttonErrorGeneric)
        break

      case global.ProblemTypes.promocodeApplicationDatesOfReservationNotValid:
        msgError.title = translate('rdPromoErrorInvalidDates')
        createErrorModal(msgError, buttonErrorGeneric)
        break

      case global.ProblemTypes.promocodeError:
        msgError.title = translate('rdPromoError')
        createErrorModal(msgError, buttonErrorGeneric)
        break

      case global.ProblemTypes.promocodeNotApplicableGuestIsNotAssignedToPromocode:
        msgError.title = translate('rdPromoErrorGuestNotAssigned')
        createErrorModal(msgError, buttonErrorGeneric)
        break

      case global.ProblemTypes.promocodeNotApplicableGuestDoesNotMatchTheLoyaltyFilter:
        msgError.title = translate('rdPromoErrorGuestDoesNotMatch')
        createErrorModal(msgError, buttonErrorGeneric)
        break

      case global.ProblemTypes.promocodeNotApplicableDueToReservationContract:
        msgError.title = translate('rdPromoErrorDueToReservation')
        createErrorModal(msgError, buttonErrorGeneric)
        break

      case global.ProblemTypes.promocodeDiscountAreNotApplicable:
        msgError.title = translate('rdPromoErrorDiscountNotApplicable')
        createErrorModal(msgError, buttonErrorGeneric)
        break

      case global.ProblemTypes.promocodeDoesNotFitSpecialConditions:
        msgError.title = translate('rdPromoErrorDoesNotFit')
        createErrorModal(msgError, buttonErrorGeneric)
        break

      case global.ProblemTypes.promocodeClientsAreNotValid:
        msgError.title = translate('rdPromoErrorInvalidClient')
        createErrorModal(msgError, buttonErrorGeneric)
        break

      case global.ProblemTypes.promocodeIsNotActived:
        msgError.title = translate('rdPromoErrorNotActived')
        createErrorModal(msgError, buttonErrorGeneric)
        break

      default: global.ApiHandlers.handleErrorsMessage(error)
    }
  }

  return {
    errorFactoryModal,
    waittingUTAG
  }
}
